import { FC } from "react";

const MainMenuDynamic: FC = () => (
  <div className="h-full w-full bg-gray-50 dark:bg-gray-900" />
);

export default MainMenuDynamic;
